<template>
    <div id="my-download" :class="['box-model', classDisplayMode]" :style="{ display: isShow ? 'block' : 'none' }">
        <div class="overlay-mask" v-show="classDisplayMode == 'view-full'"></div>
        <div class="outter-wrapper" id="my-download-content">
            <!--head-->
            <div class="head">
                <div class="head-content">
                    <div class="head-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                            <path
                                d="M77.7777778,9.77777778 L71.5555556,2.22222222 C70.6666667,0.888888889 68.8888889,0 66.6666667,0 L13.3333333,0 C11.1111111,0 9.33333333,0.888888889 8,2.22222222 L2.22222222,9.77777778 C0.888888889,11.5555556 0,13.3333333 0,15.5555556 L0,71.1111111 C0,76 4,80 8.88888889,80 L71.1111111,80 C76,80 80,76 80,71.1111111 L80,15.5555556 C80,13.3333333 79.1111111,11.5555556 77.7777778,9.77777778 Z M40,64 L15,40 L31,40 L31,28 L49,28 L49,40 L65,40 L40,64 Z M8,10 L13.0793651,4 L66.9206349,4 L72,10 L8,10 Z">
                            </path>
                        </svg>
                    </div>
                    <h2>{{ lang($t("My Download")) }}</h2>
                    <a href="javascript:void(0);" class="btn-close dark" :tooltip="lang($t('Close'))" flow="down"
                        @click="close">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                <path
                                    d="M76 11.251l-7.252-7.251-28.748 28.749-28.749-28.749-7.251 7.251 28.749 28.749-28.749 28.748 7.251 7.252 28.749-28.748 28.748 28.748 7.252-7.252-28.748-28.748z">
                                </path>
                            </svg>
                        </div>
                    </a>
                </div>
                <div class="mobile-tab-wrapper">
                    <div class="mobile-tab">
                        <div class="bg-secondary hover-dim" :class="classToggleActiveTab('resourceList')"
                            @click="currentTab = 'resourceList'">
                            {{ lang($t("Selected List")) }}
                        </div>
                        <div class="bg-secondary hover-dimmer" :class="classToggleActiveTab('readyList')"
                            @click="currentTab = 'readyList'">
                            {{ lang($t("Ready")) }}
                        </div>
                        <div class="bg-secondary hover-dimmer" :class="classToggleActiveTab('history')"
                            @click="currentTab = 'history'">
                            {{ lang($t("History")) }}
                        </div>
                    </div>
                </div>
            </div>
            <!--end head-->

            <!--body-->
            <VuePerfectScrollbar class="body" :settings="{ maxScrollbarLength: 100 }">
                <!--list wrapper-->
                <div class="list-wrapper" v-show="isShowResourceList">
                    <!--<p class="file-title">You have <span class="text-primary txt-bold">{{ storeMyDownload.total_select }}</span> files for a total of <span class="text-primary txt-bold">{{ resource_total_size }}</span>.</p>-->

                    <p class="file-title" v-html="myDownloadInfo"></p>

                    <p class="txt-remark" v-html="myDownloadInstruct"></p>

                    <!--<p class="txt-remark">Once the file is ready, it will be available for download within 2 days. Click <span class="text-primary txt-bold">Confirm</span> at the bottom to create the file.</p>-->
                    <!--list of single resource-->
                    <div class="list-box">

                        <div v-for="(resource, key) in storeMyDownload.resource_list" class="list-item-single"
                            :class="new_resource > 0 && key < new_resource ? 'item-new' : ''">
                            <div>
                                <p>{{ resource.general.title }}</p>
                                <p class="txt-remark">
                                    <template v-if="resource.technical.format">
                                        {{ format_upper_case(resource.technical.format) }}
                                    </template>
                                    <template v-if="resource.technical.size">
                                        ({{ format_size(resource.technical.size) }}) {{ getPdfText(resource) }}
                                    </template>
                                </p>
                            </div>
                            <div>
                                <a @click.prevent="remove_resource(key)" href="javascript:void(0)"
                                    class="btn-delete dark" :tooltip="lang($t('delete'))" flow="left">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                        <path
                                            d="M25.6 5.6h4.8c0.442 0 0.8 0.358 0.8 0.8v1.6c0 0.442-0.358 0.8-0.8 0.8h-2v20c0 2.134-1.066 3.2-3.2 3.2-3.2 0-18.4 0-18.4 0-2.133 0-3.2-1.066-3.2-3.2v-20h-2c-0.442 0-0.8-0.358-0.8-0.8v-1.6c0-0.442 0.358-0.8 0.8-0.8h4.8l1.6-3.599c0.784-1.334 1.851-2.001 3.2-2.001h9.6c1.34 0 2.407 0.667 3.2 2l1.6 3.6zM25.2 8.8h-18.4v18.434c0 1.044 0.534 1.566 1.602 1.566 0 0 11.455 0 15.198 0 1.066 0 1.6-0.534 1.6-1.6v-18.4zM20.22 24.8c-0.175 0-0.319-0.060-0.432-0.18s-0.169-0.274-0.169-0.46v-11.521c0-0.186 0.056-0.34 0.169-0.46s0.256-0.18 0.432-0.18h1.2c0.175 0 0.319 0.060 0.432 0.18s0.168 0.274 0.168 0.46v11.52c0 0.187-0.056 0.34-0.168 0.46s-0.256 0.18-0.432 0.18h-1.2zM15.42 24.8c-0.175 0-0.319-0.060-0.432-0.18s-0.168-0.274-0.168-0.46v-11.521c0-0.186 0.056-0.34 0.168-0.46s0.256-0.18 0.432-0.18h1.2c0.175 0 0.319 0.060 0.432 0.18s0.168 0.274 0.168 0.46v11.52c0 0.187-0.056 0.34-0.168 0.46s-0.256 0.18-0.432 0.18h-1.2zM10.62 24.8c-0.175 0-0.319-0.060-0.432-0.18s-0.168-0.274-0.168-0.46v-11.521c0-0.186 0.056-0.34 0.168-0.46s0.256-0.18 0.432-0.18h1.2c0.175 0 0.319 0.060 0.432 0.18s0.168 0.274 0.168 0.46v11.52c0 0.187-0.056 0.34-0.168 0.46s-0.256 0.18-0.432 0.18h-1.2zM10.825 2.675l-1.225 2.925h12.8l-1.2-2.925c-0.116-0.15-0.258-0.242-0.424-0.275h-9.525c-0.167 0.033-0.308 0.125-0.425 0.275z">
                                        </path>
                                    </svg>
                                </a>
                            </div>
                        </div>

                        <div class="control" v-show="checkShowResourceAction">
                            <a @click="packZip" href="javascript:void(0)" class="action-btn h32">
                                <p>{{ lang($t("Confirm")) }}</p>
                            </a>
                            <a @click.prevent="removeAllResource" class="system-btn h32">
                                <p>{{ lang($t("Remove All")) }}</p>
                            </a>
                        </div>

                    </div>
                    <!--end list of single resource-->
                </div>
                <!--end list wrapper-->

                <!--list wrapper-->
                <div class="list-wrapper" v-show="isShowReadyList">
                    <p class="txt-bold">{{ lang($t("Ready to Download")) }}</p>
                    <!--list of package-->
                    <div class="list-box">

                        <div v-for="zip in storeMyDownload.zip_list"
                            :class="[zip.finished_zip === false ? 'item-new' : '', 'list-item-package']"
                            v-if="zip.expired === false">
                            <div style="width: 70%;">
                                <!--<p class="file-title">
                                        <span class="text-primary txt-bold">{{ zip.total_resource }}</span> files for a total of <span class="text-primary txt-bold">{{ format_size(zip.total_size) }}</span>>
                                        </p>-->


                                <p class="file-title" v-html="fileItemInfo(zip)"></p>

                                <span>{{ zip.title }}</span>
                                <p v-html="calculateTimeRemaining(zip)"></p>
                            </div>
                            <div>
                                <a href="javascript:void(0)"
                                    :class="[zip.finished_zip === false || zip.expired === true || zip.is_downloading === true ? 'dim' : '', 'btn-secondary h32']"
                                    v-on:click="startDownload(zip)">
                                    <p>{{ lang($t("Download")) }}</p>
                                </a>
                            </div>
                        </div>

                    </div>
                    <!--end list of package resource-->
                </div>
                <!--end list wrapper-->

                <div class="list-wrapper" v-show="isShowHistory">
                    <div class="filter-history-head">
                        <p class="txt-bold">{{ lang($t("History of Download")) }}</p>
                        <!--<div class="filter-history">-->
                        <!--<p>Show :</p>-->
                        <!--<ul>-->
                        <!--<li>1 month</li>-->
                        <!--<li class="on">3 months</li>-->
                        <!--<li>6 months</li>-->
                        <!--<li>1 year</li>-->
                        <!--</ul>-->
                        <!--</div>-->
                    </div>
                    <!--list of package-->
                    <div class="list-box">

                        <div class="list-item-package dim" v-for="zip in storeMyDownload.expired_list">
                            <div>
                                <!--<p class="file-title"><span class="text-primary txt-bold">{{ zip.total_resource }}</span> files for a total of <span class="text-primary txt-bold">{{ format_size(zip.total_size) }}</span>.</p>-->
                                <p class="file-title" v-html="fileItemInfo(zip)"></p>
                                <span>{{ zip.title }}</span>
                                <p class="txt-remark txt-green">{{ lang($t("Created on")) }} {{
        format_data(zip.create_at) }}</p>
                            </div>
                            <div>
                                <p class="expired">{{ lang($t("Expired")) }}</p>
                            </div>
                        </div>

                        <!--                            <div style="text-align: center; margin: 0 auto;">-->
                        <!--                                <a class="system-btn h32"  v-on:click="loadMore()" v-show="getLoadMore > 0">-->
                        <!--                                    <p>{{ lang($t("Load More")) }}</p>-->
                        <!--                                </a>-->
                        <!--                            </div>-->

                    </div>
                    <!--end list of package resource-->
                </div>
            </VuePerfectScrollbar>
            <!--end body-->
        </div>
    </div>
</template>

<script>
//TODO: user path alias
import Vue from 'vue';
import EventBus from '@common/eventBus';
import { store } from '@store/store'
import { common } from '@mixins/common';
import { storeMapper } from '@mixins/storeMapper';
import { my_download_store } from '@store/my_download'
import api from '@js/api';
import cssvar from '@sass/_variables.scss';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import mime_type from '@json/mime_type'
import XAPIJS from 'xapijs';
import { nsw_common } from '@mixins/nsw_common';

export default {
    name: "MyDownload",
    mixins: [common, storeMapper],
    data() {
        return {
            download_list: [],
            showMyDownload: false,
            displayPosition: null,
            isShow: false,
            currentTab: 'resourceList', // narrow screen 的時候, 用按判斷顯示哪個 tab content
            isDownloading: false
        }
    },
    components: {
        VuePerfectScrollbar
    },
    mounted() {
        let self = this;
        this.listenEvents();

        let my_download_content = jQuery("#my-download-content");


        jQuery(window).scroll(function (e) {
            if (my_download_content.is(":visible")) {
                console.log("window scrolling");

                var hT = my_download_content.offset().top,
                    hH = my_download_content.outerHeight(),
                    wH = jQuery(window).height(),
                    wS = jQuery(this).scrollTop();


                if (wS >= (hT + hH - wH)) {
                    self.loadMore();
                }
            }


        });
    },
    methods: {
        getPdfText(item) {
            let result = "";

            if (website_type === "special") {

                let preview = nsw_common.getTechnicalLocationByUri(item.technical.location, "hkep-preview-url-2-pdf")

                console.log(preview);

                if (preview) {
                    return "+ PDF";
                }

            }
            return result;

        },
        loadMore() {
            let self = this;
            EventBus.$emit("showGlobalLoading");
            api.getDownloadData(this.getSkip, 5).then(resp => {

                self.$store.commit("my_download_store/setLoadMoreData", resp.data);
                EventBus.$emit("hideGlobalLoading");

            });
        },
        listenEvents() {
            let self = this;
            EventBus.$on("checkDownloadStatus", (id) => {
                Echo.channel(`download.${id}`)
                    .listen('.DownloadStatus', (e) => {
                        console.log('Broadcast received.');
                        console.log(e.message);

                        if (e.message === "finished") {
                            self.$store.commit("my_download_store/newNotification");
                            Echo.leaveChannel(`download.${id}`);
                            api.getDownloadData().then(resp => {
                                self.$store.commit("my_download_store/updateData", resp.data);
                            });

                        }
                    });
            });
        },
        format_upper_case(string) {
            return this.formatToUpperCase(mime_type[string]);
        },
        format_size: function (size) {
            return this.formatSize(size);
        },
        format_data: function (date) {
            var arr_date = date.split("T");
            return arr_date[0];

        },
        remove_resource(key) {

            api.removeResource(key).then(resp => {

                this.$store.commit("my_download_store/updateData", resp.data);

            }).catch(function (resp) {
                //then 放在 catch 之後, 無論 axios 成功或是失敗, 總會執行
            });

        },
        removeAllResource: function () {

            api.removeAllResource().then(resp => {

                this.$store.commit("my_download_store/updateData", resp.data);

            }).catch(function (resp) {
                //then 放在 catch 之後, 無論 axios 成功或是失敗, 總會執行
            });
        },
        packZip: function () {
            EventBus.$emit("showGlobalLoading");

            let self = this;
            api.saveMyDownloadRecord().then(resp => {

                if (resp.data) {
                    this.$store.commit("my_download_store/updateData", resp.data);

                    if (resp.data.latest_id) {
                        let id = resp.data.latest_id.$oid;
                        EventBus.$emit("checkDownloadStatus", id);

                    }

                }
                EventBus.$emit("hideGlobalLoading");

            }).catch(function (resp) {
                EventBus.$emit("hideGlobalLoading");

            });

        },
        calculateTimeRemaining(zip) {
            var difference = zip.time_different;

            var daysDifference = Math.floor(difference / 86400);
            difference -= daysDifference * 86400;

            var hoursDifference = Math.floor(difference / 60 / 60);

            if (zip.finished_zip === false) {

                return `<p class="txt-remark text-processing">${this.lang(this.$t("Preparing"))}...</p>`;
                //var mins = Math.floor(zip.estimated_zip_time/60);
                //return "<p class=\"txt-remark text-processing\">Estimated time takes "+mins+" mins...</p>"
                // return `<p class="txt-remark text-processing">${this.lang(this.$t("Estimated time takes %mins% mins.."),  {mins: mins})}</p>`;
            }

            if (zip.expired || daysDifference < 0) {
                return `<p class="txt-remark">${this.$t("Expired")}</p`;
            }

            return `<p class="txt-remark txt-allow">${this.remainingDisplay(daysDifference, hoursDifference)}</p>`;

        },
        close() {
            document.body.style.overflowX = "auto";
            this.isShow = false;
            this.$store.commit("my_download_store/offNotification");

        },
        show(displayPosition) {
            document.body.style.overflowX = "hidden";
            this.displayPosition = displayPosition;
            this.isShow = true;
            EventBus.$emit("closeFilter");
        },
        classToggleActiveTab(currentTab) {
            return (this.currentTab === currentTab) ? 'on' : '';
        },
        fileItemInfo(zip) {

            return this.lang(this.$t("%num_files% files for a total of %total_size%"),
                {
                    num_files: `<span class="text-primary txt-bold">${zip.total_resource}</span>`,
                    total_size: `<span class="text-primary txt-bold">${this.format_size(zip.total_size)}</span>`
                })
        },
        remainingDisplay(day, hour) {
            return this.lang(this.$t("%day% day(s) %hour% hr(s) remaining"), {
                day: day,
                hour: hour
            })
        },
        startDownload(zip) {

            let self = this;

            if (zip && !self.isDownloading) {

                if (zip.finished_zip === false || zip.expired === true || zip.is_downloading === true) {
                    return false;
                }
                self.isDownloading = true;
                zip.is_downloading = true;
                EventBus.$emit("showGlobalLoading");

                var url = '/api/learning_obj/rt_pack_resource?id=' + zip.id.$oid;

                window.open(url);

                var xapijs = new XAPIJS(xapi_config, access_token);

                var list = [];

                if (zip.resource_list) {
                    zip.resource_list.forEach(function (obj) {
                        list.push({
                            id: window.getFileApi + obj.id.uri,
                            filename: obj.technical.filename
                        });
                    });
                }

                xapijs.downloadZip(
                    display_name,
                    membercode,
                    zip.filename,
                    window.domain + url,
                    list
                );
                setTimeout(function () {
                    self.isDownloading = false;
                }, 5000);

                EventBus.$emit("hideGlobalLoading");

            }

        }
    },
    computed: {
        getSkip() {
            return this.storeMyDownload.skip;
        },
        getLoadMore() {
            return this.storeMyDownload.load_more;
        },
        resource_total_size() {
            return this.formatSize(this.storeMyDownload.total_size);

        },
        checkShowResourceAction() {
            return this.storeMyDownload.total_select > 0;
        },
        new_resource() {
            return this.storeMyDownload.num_of_new_resource;
        },
        checkShowMydownloadTitle() {
            return this.storeMyDownload.zip_list.length > 0;
        },
        //檢查從哪裡開啟my download, 從上方, 開啟大的my download, 否則, 開啟細的my download
        classDisplayMode() {

            if (this.displayPosition === "top") {
                return "view-full";
            } else if (this.displayPosition === "bottom") {
                return (this.$mq === cssvar.narrow) ? "view-full" : "view-pop";
            }
        },
        isShowResourceList() {
            if (this.$mq === cssvar.narrow) {
                if (this.currentTab === 'resourceList') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return this.displayPosition === 'bottom' || (this.displayPosition === 'top' && this.currentTab === 'resourceList') || this.$mq === cssvar.wide

            }

            return false;

        },
        isShowReadyList() {

            if (this.$mq === cssvar.narrow) {
                if (this.currentTab === 'readyList') {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (this.storeMyDownload.zip_list.length) {
                    return this.displayPosition === 'bottom' || (this.displayPosition === 'top' && this.currentTab === 'readyList') || this.$mq === cssvar.wide;
                }
            }

            return false;
        },
        //Condition A: 按下 header 的 mydownload button , 且有 history result 時才會熕示 download history
        //Under conditionA, 如果是narrow screen 的話, 按下 history tab 才 show, 如果是 wide screen 的話, always show
        //Condition B: 按下 footer 的 mydownload button 則無論如何都不顯示 history
        isShowHistory() {


            if (this.$mq === cssvar.narrow) {
                if (this.currentTab === 'history') {
                    return true;
                } else {
                    return false;
                }
            } else {

                if (this.storeMyDownload.expired_list !== undefined) {
                    return this.displayPosition === 'top' && this.storeMyDownload.expired_list.length > 0 && ((this.currentTab === 'history' && this.$mq === cssvar.narrow) || this.$mq === cssvar.wide)
                }
            }

            return false;

        },
        myDownloadInfo() {
            return this.lang(this.$t("%num_files% files for a total of %total_size%"),
                {
                    num_files: `<span class="text-primary txt-bold">${this.storeMyDownload.total_select}</span>`,
                    total_size: `<span class="text-primary txt-bold">${this.resource_total_size}</span>`
                }
            )
        },
        myDownloadInstruct() {
            return this.lang(this.$t("Once the file is ready, it will be available for download within 2 days. Click %confirm% at the bottom to create the file"),
                {
                    confirm: ` <span class="text-primary txt-bold">${this.$t("Confirm")}</span>`
                }
            )
        }
    }
}
</script>

<style scoped lang="scss">
@import "~@sass/_variables.scss";
@import "~@sass/_mixins.scss";
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/MyDownload.vue